import { Incarico } from './incarico';
import { Model } from './model';

export class StatoIncarico extends Model {
  nome: string;
  static apiUrl: string = "stati_incarico";

  incarichi: Incarico[];

  deserialize(input: any): StatoIncarico {
    let retV: StatoIncarico = new StatoIncarico();

    retV = super.deserialize(input) as StatoIncarico;

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    }

    return retV;
  }
}

